import React, { useState } from 'react';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import {
    Header,
    ContentBody,
    HeaderContainer,
    DetailBody,
} from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport.styled';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import PdfLoading from 'src/pages/orders/components/reportsAndInvoice/viewReport/PdfLoading';
import {
    isIpad,
    isMobileView,
} from 'src/utils/util';
import { PdfMainContainer } from 'src/pages/equity/components/shipping/addPoTissue/AddPo.styled';
import { LARGE_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

const PreviewImage = ({ previewImage, onClosePreview }) => {
    const [numPages, setNumPages] = useState(null);

    if (!previewImage) return null;

    const onDocumentLoadSuccess = ({ numPages }) => { 
        setNumPages(numPages);
    };

    const getUrl = () => {
        if (previewImage.type === 'pdf') {
            return URL.createObjectURL(previewImage.file);
        }
        return previewImage.preview;
    };

    const isImageFile = () => {
        return previewImage.type === 'image';
    };

    return (
        <ModalDialog
            modalHeight={'calc(100vh - 150px)'}
            modalWidth={'70%'}
            left={'0%'}
            right={'0%'}
            top={'7%'}
            bottom={'5%'}
            padding={'0px'}
            height={'100%'}
            marginTop={'6.75rem'}
            zIndex={'30000'}
            width={'50%'}
            onClick={() => {}}
            handleClose={onClosePreview}
            id={`modal-dialog-${previewImage?.name || 'unknown'}`}
        >
            <ContentBody contentHeight={'calc(100% - 16px)'}>
                <HeaderContainer>
                    <Header className="uploaded-document-preview-name-dt-mask" fontSize={LARGE_TEXT_PX}>
                        {previewImage.name}
                    </Header>
                </HeaderContainer>

                <DetailBody
                    detailBodyPadding={'0px'}
                    overflowX={'hidden'}
                    pdfContainerHeight={'unset'}
                    scrollBarWidth={'8px'}
                    scrollBarBackgroundColor={'#888'}
                    scrollBarBorderRadius={'10px'}
                    mediumDeviceScrollBarDisplay={'block'}
                >
                    <PdfMainContainer className="uploaded-document-preview-content-dt-mask">
                        {isImageFile() ? (
                            <img
                                height={'100%'}
                                width={'50%'}
                                src={getUrl()}
                                alt={previewImage.name}
                            />
                        ) : previewImage.type === 'pdf' ? (
                            <Document
                                file={getUrl()}
                                onLoadSuccess={onDocumentLoadSuccess}
                                width="100%"
                                renderMode={'canvas'}
                                loading={<PdfLoading />}
                            >
                                {[...Array(numPages).keys()].map((element, index) => (
                                    <Page
                                        index={element + 1}
                                        pageNumber={element + 1}
                                        scale={
                                            isIpad() || isMobileView()
                                                ? 1.0
                                                : 1.5
                                        }
                                        key={index}
                                    />
                                ))}
                            </Document>
                        ) : (
                            <iframe
                                src={getUrl()}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 'none',
                                    backgroundColor: '#fff'
                                }}
                                title={previewImage.name}
                            />
                        )}
                    </PdfMainContainer>
                </DetailBody>
            </ContentBody>
        </ModalDialog>
    );
};

export default PreviewImage;
